{
  "en": {
    "session": {
      "error_internalserver": {
        "goback": "Go back",
        "subtitle": "Oops, an unexpected error seems to have occurred.",
        "title": "500"
      },
      "error_notfound": {
        "goback": "Go back",
        "subtitle": "Sorry, the page you are looking for could not be found.",
        "title": "404"
      },
      "expired": {
        "text": "Your session has expired due to inactivity. For security reasons, you are required to login again. \n\nClick OK to be redirected to the login screen.",
        "title": "Session Expired"
      },
      "logout_impersonate": {
        "text": "A logout action has been triggered during impersonation.",
        "title": "Impersonation stopped"
      },
      "noaccess": {
        "text": "You might be affected by our most recent <b>update</b>: <p></p> <ul> <li>&nbsp;</li> <li><b>Team members and partners</b> from now have access (and login) via <b>ziggu.app</b> (instead of <i>%company%</i>.ziggu.app)</li> <li>&nbsp;</li> <li><b>Customers</b> are unaffected and can still access the platform via <b><i>%company%</i>.ziggu.app</b> </ul> <p>&nbsp;</p> <p>Clicking OK will redirect you to the appropriate page.</p> <p>If you continue to experience issues, please reach out to us.</p>",
        "title": "Oops.. you don't seem to have access to this page (any longer)."
      }
    }
  }
}